import { useState } from 'react'
import axios from 'axios'
import { useGoogleLogin } from '@react-oauth/google'
import { useDispatch } from 'react-redux'
import fusionAPI from '../api/fusionApi'
import { getUserGoogleAuth } from '../Login.action'
import useQuery from './useQuery'

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || ''
const applicationId = process.env.REACT_APP_FUSION_APP_ID
const googleId = process.env.REACT_APP_FUSION_GOOGLE_ID
const googleClientSecret = process.env.REACT_APP_GOOGLE_CLIENT_SECRET
const googleTokenAPI = 'https://oauth2.googleapis.com/token'

export const useGoogleAuth = () => {
    const query = useQuery()
    const dispatch = useDispatch()
    const [error, setError] = useState('')
    const referrer = query.get('referrer')

    const handleSuccess = async (response) => {
        const googleLoginResponse = response
        try {
            const { code } = googleLoginResponse
            const payload = {
                code,
                client_id: googleClientId,
                client_secret: googleClientSecret,
                redirect_uri: 'postmessage',
                grant_type: 'authorization_code',
            }

            const {
                data: { id_token },
            } = await axios.post(googleTokenAPI, payload)

            const response = await fusionAPI.identityProviderLogin({
                applicationId,
                identityProviderId: googleId,
                data: {
                    token: id_token,
                },
            })

            if (response.wasSuccessful()) {
                const hasSavedReferrer = Boolean(
                    response?.response?.user?.data?.referrer
                )

                if (referrer && !hasSavedReferrer) {
                    await fusionAPI.updateUser(response.response.user.id, {
                        user: {
                            ...response.response.user,
                            data: { referrer },
                        },
                    })
                }
                dispatch(getUserGoogleAuth(response))
            } else {
                handleError('Google authentication failed')
                setError('Google authentication failed')
            }
        } catch (error) {
            handleError(error)
            setError('Google authentication failed')
        }
    }

    const handleError = (error) => {
        console.log({ error })
    }

    const signIn = useGoogleLogin({
        onSuccess: handleSuccess,
        onFailure: handleError,
        flow: 'auth-code',
    })

    return { signIn, error }
}
